import 'whatwg-fetch';
import {debounce} from 'debounce';

document.addEventListener('DOMContentLoaded', () => {
    const newDiv = document.createElement('div');
    // noinspection CheckTagEmptyBody
    newDiv.innerHTML = [
        '<span>',
        'Возможно, вы имели в виду <span id="email-suggestion-text"></span>?',
        '<div><a href="#" id="email-suggestion-accept">да, заменить</a></div>',
        '</span>',
    ].join('');
    const email_input = document.getElementById('email');
    email_input.parentNode.appendChild(newDiv);
    const suggestion = document.getElementById('email-suggestion-text');
    const link = document.getElementById('email-suggestion-accept');

    newDiv.style.display = 'none';

    let last_suggestion;

    async function on_edit() {
        const response = await fetch('/api/check_email', {
            method: 'POST',
            body: JSON.stringify({email: email_input.value}),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        const content = await response.json();
        if (content.suggest) {
            newDiv.style.display = null;
            suggestion.innerText = content.suggest;
            last_suggestion = content.suggest;
        } else {
            newDiv.style.display = 'none';
        }
    }

    email_input.addEventListener('keyup', debounce(on_edit, 1000));

    link.addEventListener('click', (event) => {
        event.preventDefault();
        email_input.value = last_suggestion;
        newDiv.style.display = 'none';
    });
});
